export enum PromoType {
  VOLUMETRIC = "VOLUMETRIC",
  BASKET = "BASKET",
  DYNAMIC = "DYNAMIC",
  USER_LEVEL = "USER_LEVEL",
}

export const PromoOptions = Object.keys(PromoType).map((key) => ({
  id: key,
  key,
  title: key,
}));
